// extracted by mini-css-extract-plugin
module.exports = {"editDocumentWindow":"editDocumentWindow__bvUM-","modalDialog":"modalDialog__l0+KB","contentClassName":"contentClassName__l2AWw","contentWrap":"contentWrap__oxtn6"};